// src/components/OwnerPortalPage/OwnerPortalPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import PortalSidebar, {
  usePortalTab,
} from "../PortalSidebar/PortalSidebar";

const OwnerPortalPage = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  // EXISTING
  const [ownerAccounts, setOwnerAccounts] = useState([]);
  const [expandedOwnerId, setExpandedOwnerId] = useState(null);
  const [loadingAccounts, setLoadingAccounts] = useState(true);
  const [errorAccounts, setErrorAccounts] = useState(null);

  // 🆕 TENANT ACCOUNTS STATE
  const [tenantAccounts, setTenantAccounts] = useState([]);
  const [expandedTenantOwnerId, setExpandedTenantOwnerId] = useState(null);
  const [loadingTenantAccounts, setLoadingTenantAccounts] = useState(false);
  const [errorTenantAccounts, setErrorTenantAccounts] = useState(null);

  const [buildings, setBuildings] = useState([]);
  const [loadingBuildings, setLoadingBuildings] = useState(false);
  const [errorBuildings, setErrorBuildings] = useState(null);

const [activeTab, setActiveTab] = usePortalTab("owner");
  const navigate = useNavigate();
  const location = useLocation();
  // ─── My Tickets ──────────────────────────────────────────────
  const [tickets, setTickets] = useState([]);
  const [groupedTickets, setGroupedTickets] = useState({});
  const [expandedTicketBuilding, setExpandedTicketBuilding] = useState(null);
  const [loadingTickets, setLoadingTickets] = useState(false);
  const [errorTickets, setErrorTickets] = useState(null);
  const [ticketSubTab, setTicketSubTab] = useState("current");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  const groupTicketsByBuilding = (tickets) =>
    tickets.reduce((acc, t) => {
      const name =
        t[
          "_cr446_relatedbuilding_value@OData.Community.Display.V1.FormattedValue"
        ] ||
        t.building ||
        "Unassigned";
      const id = t["_cr446_relatedbuilding_value"] || t.buildingGuid || null;
      if (!acc[name]) acc[name] = { buildingGuid: id, items: [] };
      acc[name].items.push(t);
      return acc;
    }, {});

  useEffect(() => {
    if (activeTab !== "tickets") return;
    setLoadingTickets(true);
    setErrorTickets(null);

    const token = localStorage.getItem("token");
    const userProfileId = localStorage.getItem("userProfileId");
    const endpoint =
      ticketSubTab === "current"
        ? `https://portal.gmacc.co.za/api/tickets/owner/active/${userProfileId}/`
        : `https://portal.gmacc.co.za/api/tickets/owner/inactive/${userProfileId}/`;

    fetch(endpoint, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        setTickets(data);
        setGroupedTickets(groupTicketsByBuilding(data));
      })
      .catch((err) => setErrorTickets(err.message || "Failed to load tickets"))
      .finally(() => setLoadingTickets(false));
  }, [activeTab, ticketSubTab]);

  // ─── Fetch Owner Accounts ──────────────────────────────────
  useEffect(() => {
    const fetchOwnerAccounts = async () => {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/");
      try {
        const res = await fetch(
          "https://portal.gmacc.co.za/api/owner-accounts-linked/",
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        const data = await res.json();
        if (res.ok) {
          setOwnerAccounts(data);
        } else {
          setErrorAccounts(data.error || "Failed to fetch accounts");
        }
      } catch {
        setErrorAccounts("Network error fetching accounts");
      } finally {
        setLoadingAccounts(false);
      }
    };
    fetchOwnerAccounts();
  }, [navigate, location.pathname]);

  // ─── Fetch Tenant Accounts ─────────────────────────────────
  useEffect(() => {
    if (activeTab !== "tenant") return;
    const loadTenants = async () => {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/");
      setLoadingTenantAccounts(true);
      setErrorTenantAccounts(null);
      try {
        const res = await fetch(
          "https://portal.gmacc.co.za/api/owner-tenant-accounts/",
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        const data = await res.json();
        if (res.ok) {
          setTenantAccounts(data);
        } else {
          setErrorTenantAccounts(
            data.error || "Failed to fetch tenant accounts",
          );
        }
      } catch (e) {
        setErrorTenantAccounts("Network error fetching tenant accounts");
      } finally {
        setLoadingTenantAccounts(false);
      }
    };
    loadTenants();
  }, [activeTab, navigate]);

  // ─── Build Buildings from levy_accounts ────────────────────
  useEffect(() => {
    if (activeTab !== "buildings" || loadingAccounts) return;
    const map = new Map();
    ownerAccounts.forEach((owner) => {
      owner.levy_accounts?.forEach((levy) => {
        if (levy.building && levy.buildingId && !map.has(levy.buildingId)) {
          map.set(levy.buildingId, {
            building: levy.building,
            buildingGuid: levy.buildingId,
          });
        }
      });
    });
    const buildings = Array.from(map.values());

    console.log("Buildings:", buildings);

    setBuildings(buildings);

    localStorage.setItem("owner_buildings", JSON.stringify(buildings));

    console.log(
      "Fetched Buildings:",
      JSON.parse(localStorage.getItem("owner_buildings")),
    );
  }, [activeTab, ownerAccounts, loadingAccounts]);

  const toggleExpand = (id, setter, current) =>
    setter(current === id ? null : id);

  const formatCurrency = (amt) => {
    const n = Number(amt);
    const value = isNaN(n) ? 0 : n;
    return `${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "\u2002")}`;
  };

  // userAccess dropdown (now it will live in the left sidebar)
  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);
  const [displayName, setDisplayName] = useState("");
  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id, firstname, lastname, name } = decoded || {};

        // Set display name safely
        const fullName =
          firstname && lastname
            ? `${firstname} ${lastname}`
            : name
              ? name
              : email || "User";

        setDisplayName(fullName);

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          },
        );

        const data = await resp.json();
        if (resp.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Default sidebar state based on device width
  useEffect(() => {
  const handleResize = () => {
    const desktop = window.innerWidth >= 1024;
    setIsDesktop(desktop);

    // Only force closed when moving to smaller screens.
    // On desktop, keep whatever state the user last chose.
    if (!desktop) {
      setSidebarOpen(false);
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);
  useEffect(() => {
  function handleClick(e) {
    // On desktop/laptop, only the burger should control the sidebar
    if (isDesktop) return;

    const sidebar = document.getElementsByClassName(styles.sidebar)[0];
    const hamburger = document.getElementsByClassName(styles.menuBtn)[0];

    if (!sidebar || !hamburger) return;

    const clickedInsideSidebar = sidebar.contains(e.target);
    const clickedHamburger = hamburger.contains(e.target);

    if (sidebarOpen && !clickedInsideSidebar && !clickedHamburger) {
      setSidebarOpen(false);
    }
  }

  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
}, [sidebarOpen, isDesktop]);

  const handleTrusteePortalClick = () => navigate("/trustee-portal");

  const getAccountType = (levy, fallback) =>
    levy?.account_type ||
    levy?.accountType ||
    levy?.account_type_formatted ||
    levy?.["ab_accounttype@OData.Community.Display.V1.FormattedValue"] ||
    levy?.["cr446_accounttype@OData.Community.Display.V1.FormattedValue"] ||
    fallback;
const handleLandlordPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "landlord");
    navigate("/rental-portal");
  };

  const handleTenantPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "tenant");
    navigate("/rental-portal");
  };

  // ⬇️ UI
  return (
    <div className={styles.page}>
      {/* TOP BAR – match screenshot */}
      <header className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <img src={logoimage} alt="GMA Logo" className={styles.topLogo} />

          {/* HAMBURGER: opens/closes sidebar */}
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setSidebarOpen((v) => !v)}
          >
            ☰
          </button>

          <h1 className={styles.topTitle}>OWNER PORTAL</h1>
        </div>

        {/* USER CHIP: opens dropdown */}
        <div
          className={styles.userChip}
          onClick={() => {
            navigate("/user-profile");
          }}
          style={{ cursor: "pointer" }}
        >
          <span className={styles.statusDot}></span>
          <span className={styles.userName}>{displayName} ▾</span>
        </div>
      </header>

      {/* MAIN LAYOUT: LEFT SIDEBAR + RIGHT CONTENT */}
      <div className={styles.shell}>
        {/* LEFT MENU (dropdown items moved here) */}
        <PortalSidebar
  activePortal="owner"
  activeTab={activeTab}
  onTabChange={setActiveTab}
  userAccess={userAccess}
  loadingAccess={loadingAccess}
  sidebarOpen={sidebarOpen}
/>

        {/* RIGHT CONTENT */}
        <main className={styles.contentArea}>
          <div className={styles.panel}>
            {/* ACCOUNTS TAB */}
            {activeTab === "accounts" && (
              <>
                {loadingAccounts ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorAccounts ? (
                  <p className={styles.errorText}>{errorAccounts}</p>
                ) : ownerAccounts.length === 0 ? (
                  <p className={styles.errorText}>No Owner Accounts Found.</p>
                ) : (
                  ownerAccounts.map((owner) => (
                    <div
                      key={owner.id}
                      className={`${styles.expandableDiv} ${
                        expandedOwnerId === owner.id ? styles.expanded : ""
                      }`}
                    >
                      {/* header bar */}
                      <div
                        className={styles.divHeader}
                        onClick={() =>
                          toggleExpand(
                            owner.id,
                            setExpandedOwnerId,
                            expandedOwnerId,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className={styles.section}>
                          <span>Name:</span>
                          <span>{owner.owner_account_name}</span>
                        </div>
                        <div className={styles.section}>
                          <span>ID:</span>
                          <span>{owner.registration_id}</span>
                        </div>
                        <div className={styles.section}>
                          <span>Phone:</span>
                          <span>{owner.phone_number}</span>
                        </div>
                        <div className={styles.section}>
                          <span>Email:</span>
                          <span>{owner.email}</span>
                        </div>
                        <div
                          className={styles.actions}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            className={styles.pillHeaderBtnLight}
                            onClick={() =>
                              navigate(`/account-detail-view/${owner.id}`)
                            }
                          >
                            Modify
                          </button>
                          <button
                            className={styles.pillHeaderBtnLight}
                            onClick={() =>
                              toggleExpand(
                                owner.id,
                                setExpandedOwnerId,
                                expandedOwnerId,
                              )
                            }
                          >
                            {expandedOwnerId === owner.id
                              ? "Show less ▲"
                              : "Show more ▼"}
                          </button>
                        </div>
                      </div>

                      {expandedOwnerId === owner.id && (
                        <>
                          <div className={styles.separator} />
                          {!owner.levy_accounts ||
                          owner.levy_accounts.length === 0 ? (
                            <p className={styles.errorText}>
                              No Levy Accounts for this Owner.
                            </p>
                          ) : (
                            <>
                              <div className={styles["levy-header"]}>
                                <span>Levy:</span>
                                <span>Complex:</span>
                                <span>Unit:</span>
                                <span>Current:</span>
                                <span />
                                <span />
                              </div>
                              {owner.levy_accounts.map((levy) => (
                                <div
                                  key={levy.id}
                                  className={styles["levy-row"]}
                                >
                                  <span>
                                    {levy.levy_name} ({getAccountType(levy)})
                                  </span>
                                  <span>{levy.building}</span>
                                  <span>{levy.door_number}</span>
                                  <span className={styles.ownerAmountCell}>
                                    {formatCurrency(levy.current_balance)}
                                  </span>
                                  <button
                                    className={styles.buildingViewBtn}
                                    onClick={() =>
                                      navigate(
                                        `/levy-account-detail/${levy.id}/${owner.id}`,
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                  <button
                                    className={styles.buildingViewBtn}
                                    onClick={() =>
                                      navigate(`/download-statement/`, {
                                        state: {
                                          sageAccountNumber: levy.levy_name,
                                          gmaAccountNumberID: levy.id,
                                          userEmail:
                                            localStorage.getItem("userEmail"),
                                          userProfileID:
                                            localStorage.getItem(
                                              "userProfileId",
                                            ),
                                        },
                                      })
                                    }
                                  >
                                    Download Statement
                                  </button>
                                </div>
                              ))}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ))
                )}
              </>
            )}

            {/* TENANT ACCOUNTS TAB */}
            {activeTab === "tenant" && (
              <>
                {loadingTenantAccounts ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorTenantAccounts ? (
                  <p className={styles.errorText}>{errorTenantAccounts}</p>
                ) : tenantAccounts.length === 0 ? (
                  <p className={styles.errorText}>No Tenant Accounts Found.</p>
                ) : (
                  tenantAccounts.map((owner) => (
                    <div
                      key={owner.id}
                      className={`${styles.expandableDiv} ${
                        expandedTenantOwnerId === owner.id
                          ? styles.expanded
                          : ""
                      }`}
                    >
                      <div
                        className={styles.divHeader}
                        onClick={() =>
                          toggleExpand(
                            owner.id,
                            setExpandedTenantOwnerId,
                            expandedTenantOwnerId,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className={styles.section}>
                          <span>Name:</span>
                          <span>{owner.owner_account_name}</span>
                        </div>
                        <div className={styles.section}>
                          <span>ID:</span>
                          <span>{owner.registration_id}</span>
                        </div>
                        <div className={styles.section}>
                          <span>Phone:</span>
                          <span>{owner.phone_number}</span>
                        </div>
                        <div className={styles.section}>
                          <span>Email:</span>
                          <span>{owner.email}</span>
                        </div>
                        <div
                          className={styles.actions}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            className={styles.pillHeaderBtnLight}
                            onClick={() =>
                              navigate(`/account-detail-view/${owner.id}`)
                            }
                          >
                            Modify
                          </button>
                          <button
                            className={styles.pillHeaderBtnLight}
                            onClick={() =>
                              toggleExpand(
                                owner.id,
                                setExpandedTenantOwnerId,
                                expandedTenantOwnerId,
                              )
                            }
                          >
                            {expandedTenantOwnerId === owner.id
                              ? "Show less ▲"
                              : "Show more ▼"}
                          </button>
                        </div>
                      </div>

                      {expandedTenantOwnerId === owner.id && (
                        <>
                          <div className={styles.separator} />
                          {!owner.levy_accounts ||
                          owner.levy_accounts.length === 0 ? (
                            <p className={styles.errorText}>
                              No Tenant Levy Accounts linked to your Units.
                            </p>
                          ) : (
                            <>
                              <div className={styles["levy-header"]}>
                                <span>Levy:</span>
                                <span>Complex:</span>
                                <span>Unit:</span>
                                <span>Current:</span>
                                <span />
                                <span />
                                <span />
                              </div>
                              {owner.levy_accounts.map((levy) => (
                                <div
                                  key={levy.id}
                                  className={styles["levy-row"]}
                                >
                                  <span>
                                    {levy.levy_name} ({getAccountType(levy)})
                                  </span>
                                  <span classname={styles[""]}>
                                    {levy.building}
                                  </span>
                                  <span>{levy.door_number}</span>
                                  <span className={styles.ownerAmountCell}>
                                    {formatCurrency(levy.current_balance)}
                                  </span>
                                  <button
                                    className={styles.buildingViewBtn}
                                    onClick={() =>
                                      navigate(
                                        `/levy-account-detail/${levy.id}/${levy.responsible_person_id}`,
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                  <button
                                    className={styles.buildingViewBtn}
                                    onClick={() =>
                                      navigate(`/download-statement/`, {
                                        state: {
                                          sageAccountNumber: levy.levy_name,
                                          gmaAccountNumberID: levy.id,
                                          userEmail:
                                            localStorage.getItem("userEmail"),
                                          userProfileID:
                                            localStorage.getItem(
                                              "userProfileId",
                                            ),
                                        },
                                      })
                                    }
                                  >
                                    Download Statement
                                  </button>
                                </div>
                              ))}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ))
                )}
              </>
            )}

            {/* BUILDINGS TAB */}
            {activeTab === "buildings" && (
              <>
                {loadingBuildings ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorBuildings ? (
                  <p className={styles.errorText}>{errorBuildings}</p>
                ) : buildings.length === 0 ? (
                  <p className={styles.errorText}>No Buildings Found.</p>
                ) : (
                  buildings.map((b) => (
                    <div
                      key={b.buildingGuid}
                      className={styles.buildingStrip}
                      onClick={() =>
                        navigate(`/building-owner-info/${b.buildingGuid}`)
                      }
                    >
                      <div className={styles.buildingName}>{b.building}</div>
                      <button
                        className={styles.buildingViewBtn}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/building-owner-info/${b.buildingGuid}`);
                        }}
                      >
                        View Building
                      </button>
                    </div>
                  ))
                )}
              </>
            )}

            {/* TICKETS TAB */}
            {activeTab === "tickets" && (
              <>
                {/* sub tabs */}
                <div className={styles.subTabs}>
                  <div
                    className={
                      ticketSubTab === "current"
                        ? styles.subTabActive
                        : styles.subTab
                    }
                    onClick={() => setTicketSubTab("current")}
                  >
                    Current
                  </div>
                  <div
                    className={
                      ticketSubTab === "history"
                        ? styles.subTabActive
                        : styles.subTab
                    }
                    onClick={() => setTicketSubTab("history")}
                  >
                    History
                  </div>
                </div>

                {loadingTickets ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorTickets ? (
                  <p className={styles.errorText}>{errorTickets}</p>
                ) : Object.keys(groupedTickets).length === 0 ? (
                  <p className={styles.errorText}>
                    {ticketSubTab === "current"
                      ? "No Active Tickets Found."
                      : "No Historical Tickets Found."}
                  </p>
                ) : (
                  Object.entries(groupedTickets).map(([building, group]) => (
                    <div key={building} className={styles.expandableDiv}>
                      <div
                        className={styles.divHeader}
                        onClick={() =>
                          setExpandedTicketBuilding(
                            expandedTicketBuilding === building
                              ? null
                              : building,
                          )
                        }
                      >
                        <h3 className={styles.buildingTitle}>{building}</h3>
                        <div
                          className={styles.actions}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {group.buildingGuid && (
                            <button
                              className={styles.pillHeaderBtnLight}
                              onClick={() =>
                                navigate(
                                  `/building-owner-info/${group.buildingGuid}`,
                                )
                              }
                            >
                              View Building
                            </button>
                          )}
                          <button
                            className={styles.pillHeaderBtnLight}
                            onClick={() =>
                              setExpandedTicketBuilding(
                                expandedTicketBuilding === building
                                  ? null
                                  : building,
                              )
                            }
                          >
                            {expandedTicketBuilding === building
                              ? "Show less ▲"
                              : "Show more ▼"}
                          </button>
                        </div>
                      </div>

                      {expandedTicketBuilding === building && (
                        <>
                          <div className={styles.separator} />
                          <div className={styles.responsiveTableWrapper}>
                            <table className={styles.dataTable}>
                              <thead>
                                <tr>
                                  <th>Ticket Number</th>
                                  <th>Progress</th>
                                  <th>Description</th>
                                  <th>Created Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {group.items.map((t) => (
                                  <tr key={t.cr446_loggedticketid}>
                                    <td
                                      className={styles.linkLike}
                                      onClick={() =>
                                        navigate(
                                          `/loggedticket/${t.cr446_loggedticketid}`,
                                        )
                                      }
                                    >
                                      {t.cr446_ticketnumber}
                                    </td>
                                    <td>
                                      {
                                        t[
                                          "cr446_progress@OData.Community.Display.V1.FormattedValue"
                                        ]
                                      }
                                    </td>
                                    <td>{t.cr446_ticketdescription}</td>
                                    <td>
                                      {new Date(t.createdon).toLocaleString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        },
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </div>
                  ))
                )}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default OwnerPortalPage;
